import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBoardEmbedRoute: InvariantJiraRoute = {
	name: 'rapidboard-board-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed',
};
